import React from 'react';
import { Box, Typography } from '@mui/material';
import { Header } from '../../components';
import { customStyles } from '../../Utils/utils';
import { cardiacTokens as T } from '../../theme/cardiacTheme';

/* The staff page shell (Header + page body) for the Group Admin pages. Without a
   title it is the list-page shell the staff Reports list uses. */

interface TitledProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

/** Page body with a title row; also used inside the shared /dashboard page. */
export const TitledBody: React.FC<TitledProps> = ({ title, subtitle, actions, children }) => (
  <Box sx={{ p: '20px 30px 40px', overflowY: 'auto', flex: 1, minHeight: 0 }}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: 2,
        mb: '18px',
        flexWrap: 'wrap',
      }}
    >
      <Box>
        <Typography sx={{ fontSize: 26, fontWeight: 800, color: '#fff', lineHeight: 1.1 }}>{title}</Typography>
        {subtitle && <Typography sx={{ fontSize: 13, color: T.ink3, mt: '3px' }}>{subtitle}</Typography>}
      </Box>
      {actions}
    </Box>
    {children}
  </Box>
);

const GroupAdminLayout: React.FC<Partial<TitledProps> & { children: React.ReactNode }> = ({
  title,
  subtitle,
  actions,
  children,
}) => (
  <section
    className={`layoutContainer${title ? '' : ' cw-listpage'}`}
    style={customStyles.layoutBackground}
  >
    <div className="layoutGrid">
      <div className="page page--fullBody">
        <Header />
        <div className="page__body">
          {title ? (
            <TitledBody
              title={title}
              subtitle={subtitle}
              actions={actions}
            >
              {children}
            </TitledBody>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  </section>
);

export default GroupAdminLayout;
